import React, { FC, PropsWithChildren } from 'react';

import { StyledBulletList } from './bullet-list.styled';

export const BulletList: FC<PropsWithChildren> = (props) => <StyledBulletList {...props} />;
